import { useTranslate } from "@similarweb/i18n-provider";
import { CheckCircle } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

export const AdminManagedContent = () => {
    const { translate } = useTranslate();

    return (
        <Flex
            padding="16px 20px"
            borderRadius="8px"
            background={colorsPalettes.mint["50"]}
            gap="12px"
            border={`1px solid ${colorsPalettes.mint["400"]}`}
            alignItems="flex-start"
            fontVariant="body2"
            data-automation="extension-deployment-admin-managed-info"
        >
            <CheckCircle
                size="xs"
                color={colorsPalettes.mint["400"]}
            />
            <Stack gap="4px">
                <Text
                    as="strong"
                    fontVariant="input2Bold"
                    color={colorsPalettes.carbon["500"]}
                >
                    {translate("si.management.extension.deployment.admin_managed.title")}
                </Text>{" "}
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon["400"]}
                >
                    {translate("si.management.extension.deployment.admin_managed.description")}
                </Text>
            </Stack>
        </Flex>
    );
};
